import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hidden",
  "use": "hidden-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"hidden\"><title>hidden</title><g id=\"hidden__visibility\"><g id=\"hidden_hidden-2\" data-name=\"hidden\"><path d=\"M4.49,5.2,5.94,6.65A16.1589,16.1589,0,0,0,2.1,10.2l-.22.3.22.3c.15.21,3.79,5.05,8.4,5.05a8,8,0,0,0,3.66-1l1.64,1.64.71-.71L5.2,4.49ZM3.14,10.5A15.3807,15.3807,0,0,1,6.58,7.43a4.89,4.89,0,0,0,0,6.14A15.3807,15.3807,0,0,1,3.14,10.5Zm7.36,4a4,4,0,0,1-4-4,3.92,3.92,0,0,1,.85-2.44L8.78,9.49a1.9838,1.9838,0,0,0,2.72,2.72l1.43,1.43A3.92,3.92,0,0,1,10.5,14.5Z\" /><path d=\"M18.9,10.2c-.15-.21-3.79-5.05-8.4-5.05a7.0037,7.0037,0,0,0-1.72.22L10,6.55a3.9389,3.9389,0,0,1,.53-.05,4,4,0,0,1,4,4,3.9389,3.9389,0,0,1-.05.53l.84.84a4.7933,4.7933,0,0,0,.22-1.37,5,5,0,0,0-1.08-3.07A15.3807,15.3807,0,0,1,17.9,10.5a16.3988,16.3988,0,0,1-2,2l.72.72a16.2536,16.2536,0,0,0,2.29-2.4l.22-.3Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/hidden.svg
// module id = CCom
// module chunks = 4